module.exports = __webpack_public_path__ + "img/skinshape.409a774b.svg";